import React from 'react';
import classNames from 'classnames';
import { getBenefitsForPlan } from '../../shared/plans';
import visaLogo from '../../images/visa.svg';
import mastercardLogo from '../../images/mastercard.svg';
import amexLogo from '../../images/amex.svg';
import discoverLogo from '../../images/discover.svg';

const BENEFIT_ICONS = {
  searches: 'fa-solid fa-magnifying-glass',
  results: 'fa-solid fa-list-ol',
  domain_results: 'fa-solid fa-list-ol',
  competitors: 'fa-solid fa-chart-line',
  ranking_lists: 'fa-solid fa-list-ol',
  ranking_keywords: 'fa-solid fa-chart-line',
  countries: 'fa-solid fa-globe',
  domains: 'fa-solid fa-globe',
  exports: 'fa-solid fa-file-export',
};

export default function WithSalesBenefits({ plan, label = 'Selected Plan', hidePanel = false, children }) {
  const benefits = getBenefitsForPlan(plan);

  return (
    <div className={classNames('sales-modal-layout', { 'sales-modal-layout-full': hidePanel })}>
      <section className='sales-modal-left'>
        {children}
      </section>

      {!hidePanel && (
        <section className='sales-modal-right'>
          <div>
            <span className='sales-modal-plan-label'>{label}</span>
            <h3 className='sales-modal-plan-name'>Wordtracker {plan.tier.charAt(0).toUpperCase() + plan.tier.slice(1)}</h3>
          </div>

          <ul className='sales-modal-benefits'>
            {benefits.map(({ key, label: benefitLabel }, i) => (
              <li key={i}><i className={BENEFIT_ICONS[key] || 'fa-solid fa-check'}></i>{benefitLabel}</li>
            ))}
          </ul>

          <div className='sales-modal-stripe-trust'>
            <p>
              <i className="fa-solid fa-lock"></i>
              Guaranteed <strong>safe and secure</strong> checkout
            </p>
            <div className='sales-modal-trust-icons'>
              {/* <i className="fa-brands fa-stripe"></i> */}
              <img src={visaLogo} alt="Visa" />
              <img src={mastercardLogo} alt="Mastercard" />
              <img src={amexLogo} alt="Amex" />
              <img src={discoverLogo} alt="Discover" />
            </div>
          </div>

          <div className='sales-modal-testimonial'>
            <p className='sales-modal-testimonial-quote'>"Thanks for being less expensive than Ahrefs for my basic SEO needs!"</p>
            <p className='sales-modal-testimonial-author'>— Josh S</p>
          </div>
        </section>
      )}
    </div>
  );
}
